import React from 'react';
import styled from 'styled-components';

const StyledLinkButton = styled.button`
  padding: 4px 8px;
  margin: 3px 4px;
  border-radius: 10px;
  border: 1px solid #0069ff;
  background-color: #f8faff;
  color: #0069ff;
  font-size: 12px !important;
  cursor: pointer;
  transition: all 0.3s ease;
  width: ${props => props.width || 'auto'};
  white-space: nowrap;
  display: inline-block;
  line-height: 16px;
  box-sizing: border-box;
  text-align: left;
  text-decoration: none;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;

  /* 등장 애니메이션 */
  opacity: 0;
  transform: translateY(10px);
  animation: slideIn 0.4s ease-out forwards;
  animation-delay: ${props => props.animationDelay || '0s'};

  @keyframes slideIn {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &:hover {
    background-color: #e6f2ff;
    transform: translateY(0) scale(1.02);
  }

  &:active {
    transform: translateY(0) scale(0.98);
  }
`;

const LinkButton = ({ url, children, title, width, style, ...props }) => {
  const handleClick = () => {
    if (url) {
      window.open(url, '_blank');
    }
  };

  return (
    <StyledLinkButton
      onClick={handleClick}
      title={title || url}
      width={width}
      style={style}
      {...props}>
      {children}
    </StyledLinkButton>
  );
};

export default LinkButton;
